// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { FacebookShareButton, WhatsappShareButton, TwitterShareButton, FacebookIcon, WhatsappIcon, TwitterIcon } from "react-share";
// import "./GreetingPage.css"; // We'll create some CSS for responsive cards

// const GreetingPage = () => {
//   const [data, setData] = useState([]);
//   const [filter, setFilter] = useState("ALL");

//   // Load data from API
//   const loadData = async () => {
//     try {
//       const res = await axios.get("https://api.propertygalleria.in/master/api/greetings");
//       setData(res.data);
//     } catch (error) {
//       console.error("Error loading greetings", error);
//     }
//   };

//   useEffect(() => {
//     loadData();
//   }, []);

//   // Filtered greetings
//   const filteredData = filter === "ALL" ? data : data.filter(item => item.type === filter);

//   return (
//     <div className="greeting-container">
//       <h1>Greetings</h1>

//       {/* Filter Buttons */}
//       <div className="filter-buttons">
//         <button onClick={() => setFilter("ALL")} className={filter === "ALL" ? "active" : ""}>All</button>
//         <button onClick={() => setFilter("FESTIVAL")} className={filter === "FESTIVAL" ? "active" : ""}>Festival</button>
//         <button onClick={() => setFilter("QUOTE")} className={filter === "QUOTE" ? "active" : ""}>Quote</button>
//       </div>

//       {/* Greeting Cards */}
//       <div className="greeting-grid">
//         {filteredData.map(greeting => (
//           <div key={greeting.id} className="greeting-card">
//             {greeting.image ? (
//               <img src={greeting.image} alt={greeting.type} className="greeting-image" />
//             ) : (
//               <div className="no-image">No Image</div>
//             )}
//             <div className="greeting-content">
//               <h3>{greeting.type}</h3>
//               <p>{greeting.message}</p>

//               {/* Social Share Buttons */}
//               <div className="share-buttons">
//                 <FacebookShareButton url={greeting.image || window.location.href} quote={greeting.message}>
//                   <FacebookIcon size={32} round />
//                 </FacebookShareButton>
//                 <WhatsappShareButton url={greeting.image || window.location.href} title={greeting.message}>
//                   <WhatsappIcon size={32} round />
//                 </WhatsappShareButton>
//                 <TwitterShareButton url={greeting.image || window.location.href} title={greeting.message}>
//                   <TwitterIcon size={32} round />
//                 </TwitterShareButton>
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default GreetingPage;


import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import html2canvas from "html2canvas";
import "./GreetingPage.css";

import AgentNavBar from "./AgentNavBar";

const GreetingPage = () => {
  const [data, setData] = useState([]);
  const [filter, setFilter] = useState("ALL");

  // Load data from API
  const loadData = async () => {
    try {
      const res = await axios.get("https://api.propertygalleria.in/master/api/greetings");
      setData(res.data);
    } catch (error) {
      console.error("Error loading greetings", error);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  // Filtered greetings
  const filteredData = filter === "ALL" ? data : data.filter(item => item.type === filter);

  // Function to capture greeting card as image
  const captureAndShare1 = async (cardId) => {
    const card = document.getElementById(`card-${cardId}`);
    if (!card) return;

    const canvas = await html2canvas(card, { scale: 2 });
    canvas.toBlob((blob) => {
      if (!blob) return;

      // Create a URL for the blob
      const file = new File([blob], "greeting.png", { type: "image/png" });

      // Use Web Share API if available
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        navigator.share({
          files: [file],
          title: "Greeting",
          text: "Check out this greeting!",
        })
        .catch(err => console.error("Share failed", err));
      } else {
        // Fallback: download the image
        const link = document.createElement("a");
        link.href = URL.createObjectURL(file);
        link.download = "greeting.png";
        link.click();
      }
    });
  };


  const captureAndShare11 = async (cardId) => {
  const card = document.getElementById(`card-${cardId}`);
  if (!card) return;

  const canvas = await html2canvas(card, {
    scale: 2,
    useCORS: true,
    allowTaint: true
  });

  canvas.toBlob((blob) => {
    if (!blob) return;

    const file = new File([blob], "greeting.png", { type: "image/png" });

    if (navigator.canShare && navigator.canShare({ files: [file] })) {
      navigator.share({
        files: [file],
        title: "Greeting",
        text: "Check out this greeting!",
      });
    } else {
      const link = document.createElement("a");
      link.href = URL.createObjectURL(file);
      link.download = "greeting.png";
      link.click();
    }
  });
};

const captureAndShare2 = async (cardId) => {
  const card = document.getElementById(`card-${cardId}`);
  const shareButton = card.querySelector(".share-button");  // Select the share button inside the card

  if (!card) return;

  // Hide the share button temporarily before capturing
  if (shareButton) {
    shareButton.style.display = "none";
  }

  const canvas = await html2canvas(card, {
    scale: 2,
    useCORS: true,
    allowTaint: true
  });

  // Restore the share button after capturing
  if (shareButton) {
    shareButton.style.display = "block";
  }

  canvas.toBlob((blob) => {
    if (!blob) return;

    const file = new File([blob], "greeting.png", { type: "image/png" });

    if (navigator.canShare && navigator.canShare({ files: [file] })) {
      navigator.share({
        files: [file],
        title: "Greeting",
        text: "Check out this greeting!",
      });
    } else {
      const link = document.createElement("a");
      link.href = URL.createObjectURL(file);
      link.download = "greeting.png";
      link.click();
    }
  });
};

const captureAndShare = async (cardId) => {
  const card = document.getElementById(`card-${cardId}`);
  const profileInfo = card.querySelector(".profile-info");  // Select the profile information inside the card
  const shareButton = card.querySelector(".share-button");  // Select the share button inside the card

  if (!card) return;

  // Temporarily show the profile information before capturing
  if (profileInfo) {
    profileInfo.style.display = "block"; // Make it visible for capture
  }

  // Hide the share button temporarily before capturing
  if (shareButton) {
    shareButton.style.display = "none";
  }

  const canvas = await html2canvas(card, {
    scale: 2,
    useCORS: true,
    allowTaint: true
  });

  // Restore the share button and profile info after capturing
  if (shareButton) {
    shareButton.style.display = "block";
  }
  if (profileInfo) {
    profileInfo.style.display = "none"; // Hide it again after capturing
  }

  canvas.toBlob((blob) => {
    if (!blob) return;

    const file = new File([blob], "greeting.png", { type: "image/png" });

    if (navigator.canShare && navigator.canShare({ files: [file] })) {
      navigator.share({
        files: [file],
        title: "Greeting",
        text: "Check out this greeting!",
      });
    } else {
      const link = document.createElement("a");
      link.href = URL.createObjectURL(file);
      link.download = "greeting.png";
      link.click();
    }
  });
};



  // Fetch user profile details
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    if (!storedUser) return;

    fetch("https://api.propertygalleria.in/master/api/users/agentss")
      .then(res => res.json())
      .then(data => {
        const matchedUser = data.find(
          u => u.user_id === storedUser.id && u.role === storedUser.role
        );
        setProfile(matchedUser);
      });
  }, []);

  
  return (
    <>
      <AgentNavBar />
    <div className="greeting-container" style={{marginTop:'10%'}}>
      <h1>Greetings</h1>

      {/* Filter Buttons */}
      <div className="filter-buttons">
        <button onClick={() => setFilter("ALL")} className={filter === "ALL" ? "active" : ""}>All</button>
        <button onClick={() => setFilter("FESTIVAL")} className={filter === "FESTIVAL" ? "active" : ""}>Festival</button>
        <button onClick={() => setFilter("QUOTE")} className={filter === "QUOTE" ? "active" : ""}>Quote</button>
      </div>

      {/* Greeting Cards */}
      <div className="greeting-grid">
        {filteredData.map(greeting => (
          <div key={greeting.id} className="greeting-card" id={`card-${greeting.id}`}>
            {greeting.image ? (
              <img src={greeting.image} alt={greeting.type} className="greeting-image" />
            ) : (
              <div className="no-image">No Image</div>
            )}
            <div className="greeting-content">
              <h3>{greeting.type}</h3>
              <p>{greeting.message}</p>

   {/* <div className="profile-info" style={{ display: 'none'}}>
            <p>Name: {profile.full_name}</p>
            <p>Email: {profile.email}</p>
            <p>Mobile: {profile.mobile_number}</p>
            <p>Designation: {profile.designation || 'N/A'}</p>
          </div> */}

              {/* Conditionally render profile details only if profile is available */}
          {profile && (
            <div className="profile-info"     
            style={{
      display: 'none', // Hidden initially
      textAlign: 'left', // Align text to the right
      padding: '10px', // Optional: add padding
    }}>
              <p style={{ margin: '0',fontSize:'10px' }}> {profile.full_name}</p>
              <p style={{ margin: '0',fontSize:'10px' }}> {profile.email}</p>
              <p style={{ margin: '0',fontSize:'10px' }}> {profile.mobile_number}</p>
              <p style={{ margin: '0',fontSize:'10px' }}> {profile.designation || ''}</p>
            </div>
          )}

              {/* Capture & Share Button */}
              <button className="share-button" onClick={() => captureAndShare(greeting.id)}>Share Greeting</button>
            </div>
          </div>
        ))}
      </div>
    </div>
    </>
  );
};

export default GreetingPage;



// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import html2canvas from "html2canvas";
// import "./GreetingPage.css";
// import AgentNavBar from "./AgentNavBar";

// const GreetingPage = () => {
//   const [data, setData] = useState([]);
//   const [filter, setFilter] = useState("ALL");
//   const [profile, setProfile] = useState(null);

//   // Load data from API
//   const loadData = async () => {
//     try {
//       const res = await axios.get("https://api.propertygalleria.in/master/api/greetings");
//       setData(res.data);
//     } catch (error) {
//       console.error("Error loading greetings", error);
//     }
//   };

//   useEffect(() => {
//     loadData();
//   }, []);

//   // Filtered greetings
//   const filteredData = filter === "ALL" ? data : data.filter(item => item.type === filter);

//   // Function to capture greeting card as image and share
//   const captureAndShare = async (cardId) => {
//     const card = document.getElementById(`card-${cardId}`);
//     if (!card) return;

//     // Fetch user details
//     const storedUser = JSON.parse(localStorage.getItem("user"));
//     if (!storedUser) return;

//     fetch("https://api.propertygalleria.in/master/api/users/agentss")
//       .then(res => res.json())
//       .then(data => {
//         const matchedUser = data.find(u => u.id === storedUser.id && u.role === storedUser.role);

//         // Add user details to the greeting card before capturing the image
//         const userDetails = `
//           Name: ${matchedUser.full_name}
//           Email: ${matchedUser.email}
//           Mobile: ${matchedUser.mobile_number}
//           Designation: ${matchedUser.designation || 'N/A'}
//         `;
        
//         // Create a temporary div to display user details
//         const detailsDiv = document.createElement("div");
//         detailsDiv.innerText = userDetails;
//         detailsDiv.style.position = "absolute";
//         detailsDiv.style.bottom = "20px";  // Position the details as needed
//         detailsDiv.style.left = "20px";
//         detailsDiv.style.color = "#000";
//         detailsDiv.style.fontSize = "12px";
//         card.appendChild(detailsDiv);  // Add it to the card

//         // Hide the "Share Greeting" button before capturing
//         const shareButton = card.querySelector(".share-button");
//         if (shareButton) {
//           shareButton.style.display = "none";
//         }

//         // Capture the card using html2canvas
//         html2canvas(card, { scale: 2 }).then((canvas) => {
//           canvas.toBlob((blob) => {
//             if (!blob) return;

//             const file = new File([blob], "greeting.png", { type: "image/png" });

//             // Share the captured image via Web Share API or download as fallback
//             if (navigator.canShare && navigator.canShare({ files: [file] })) {
//               navigator.share({
//                 files: [file],
//                 title: "Greeting",
//                 text: "Check out this greeting!",
//               }).catch(err => console.error("Share failed", err));
//             } else {
//               const link = document.createElement("a");
//               link.href = URL.createObjectURL(file);
//               link.download = "greeting.png";
//               link.click();
//             }
//           });
//         });

//         // Clean up: Remove the temporary details div and show the share button again
//         card.removeChild(detailsDiv);
//         if (shareButton) {
//           shareButton.style.display = "inline-block";
//         }
//       });
//   };

//   // Fetch user profile details
//   useEffect(() => {
//     const storedUser = JSON.parse(localStorage.getItem("user"));
//     if (!storedUser) return;

//     fetch("https://api.propertygalleria.in/master/api/users/agentss")
//       .then(res => res.json())
//       .then(data => {
//         const matchedUser = data.find(u => u.id === storedUser.id && u.role === storedUser.role);
//         setProfile(matchedUser);
//       });
//   }, []);

//   return (
//     <>
//       <AgentNavBar />
//       <div className="greeting-container" style={{ marginTop: '10%' }}>
//         <h1>Greetings</h1>

//         {/* Filter Buttons */}
//         <div className="filter-buttons">
//           <button onClick={() => setFilter("ALL")} className={filter === "ALL" ? "active" : ""}>All</button>
//           <button onClick={() => setFilter("FESTIVAL")} className={filter === "FESTIVAL" ? "active" : ""}>Festival</button>
//           <button onClick={() => setFilter("QUOTE")} className={filter === "QUOTE" ? "active" : ""}>Quote</button>
//         </div>

//         {/* Greeting Cards */}
//         <div className="greeting-grid">
//           {filteredData.map(greeting => (
//             <div key={greeting.id} className="greeting-card" id={`card-${greeting.id}`}>
//               {greeting.image ? (
//                 <img src={greeting.image} alt={greeting.type} className="greeting-image" />
//               ) : (
//                 <div className="no-image">No Image</div>
//               )}
//               <div className="greeting-content">
//                 <h3>{greeting.type}</h3>
//                 <p>{greeting.message}</p>
//                 <p style={{ fontSize: '10px' }}>{greeting.url || ''}</p>

//                 {/* Capture & Share Button */}
//                 <button className="share-button" onClick={() => captureAndShare(greeting.id)}>
//                   Share Greeting
//                 </button>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </>
//   );
// };

// export default GreetingPage;
